import { defineMessage, useIntl } from 'react-intl';
import { ThirdPartyTracking } from '../../../../../../errors/user-friendly-error-message-service/code-constants';
import { useWalletRegistrationErrorContext } from '../../../contexts/wallet-registration-error-context';

const thirdPartyTrackingTooltip = defineMessage({
  description: 'Tooltip message when third party tracking is disabled during wallet registration',
  defaultMessage:
    'Third party tracking add-ons like ad-blockers restrict our ability to confirm your activity is valid so we can more effectively prevent fraud.',
  id: 'Xvz7A6',
});

export const useDisabledButtonMessage = () => {
  const intl = useIntl();
  const { errors } = useWalletRegistrationErrorContext();

  const hasThirdPartyTrackingError = errors?.some((error) => error.Code === ThirdPartyTracking);
  if (!hasThirdPartyTrackingError) {
    return null;
  }

  return intl.formatMessage(thirdPartyTrackingTooltip);
};
